var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.5h18"
  })));
};
export default SvgMinus;